import axios, { AxiosError } from 'axios';
import { AppError } from 'merchant-api';

export const offerOrchestrator = axios.create({
  baseURL: import.meta.env['VITE_OFFER_ORCHESTRATOR_URL'],
  withCredentials: true
});

offerOrchestrator.interceptors.response.use(
  response => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) throw AppError.Unauthenticated;
    if (error.response?.status === 403) throw AppError.Unauthenticated;
    return Promise.reject(error);
  }
);

export * from './useOffers/useOffers';
export * from './useOffers/useOffersMock';
export * from './getPricingDetails/getPricingDetails';
export * from './getPricingDetails/getPricingDetailsMock';
export * from './useDetailedOffers/useDetailedOffers';
export * from './useDetailedOffers/useDetailedOffersMock';
export * from './selectOffer/selectOffer';
export * from './getPricingDetails/helper';
export * from './selectOffer/helper';